<template>
  <div class="delete-team-from-grid-match-wrapper">
    <h5>Вы действительно хотите удалить <b>{{ params.team.name }}</b> из матча?</h5>
    <h5 class="font-weight-bold mt-3">Укажите причину:</h5>
    <div v-for="reason in reasonsForDelete" :key="'reasonId' + reason.id" class="form-check">
      <input class="form-check-input"
             type="radio" name="reasonsForDeleteFromGridMatch"
             :id="'grid-match-reason-' + reason.id"
             v-model="formModel.reject_description"
             :value="reason.text">
      <label class="form-check-label" :for="'grid-match-reason-' + reason.id">{{reason.text}}</label>
    </div>
    <footer>
      <b-button @click="submitForm" :disabled="isLoadingSaveForm">
        {{ isLoadingSaveForm ? 'Удаляем...' : 'Удалить' }}
      </b-button>
    </footer>
    <b-alert v-if="errorText" show variant="danger" style="margin: 10px 0 0 0">{{ errorText }}</b-alert>
  </div>
</template>

<script>
import api from "@/api/api";
import {reasonsForDelete} from '@/constants/reasonsForDeleteTeam';

/**
 * Удаление команды из ячейки MLBB-сетки.
 *
 * Повторяет модалку удаления из группы в PUBG: та же причина удаления
 * вместо голого confirm, чтобы в обеих играх команда снималась одинаково.
 */
export default {
  name: "DeleteTeamFromGridMatchMlbb",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reasonsForDelete,
      isLoadingSaveForm: false,
      errorText: null,
      formModel: {
        reject_description: ''
      }
    }
  },
  methods: {
    async submitForm() {
      try {
        this.errorText = null
        this.isLoadingSaveForm = true
        await api.grid.deleteTeamFromGroup(
            this.params.groupId,
            this.params.team.id,
            {...(this.formModel.reject_description && {delete_description: this.formModel.reject_description})})
        this.$emit('submit', this.params.team)
        this.$emit('closeModal')
      } catch (e) {
        const data = e?.response?.data
        const message = data?.message || e?.message || 'Не удалось удалить команду из матча'
        let errors = ''
        if (data?.errors) errors = Object.entries(data.errors).map(([ name, values ]) => `${ name }: ${ values.join(', ') }`).join('. ')
        this.errorText = `${ message }; ${ errors }.`
      } finally {
        this.isLoadingSaveForm = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.delete-team-from-grid-match-wrapper {
  h5 {
    font-size: 16px;
    font-weight: 400;
  }
  footer {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin-top: 15px;
    text-align: right;
  }
}
</style>
